import './index.css';
import '@/styles/global.scss';

import { Outlet, useLocation } from '@modern-js/runtime/router';
import { Provider } from '@modern-js/runtime/model';
import { Helmet } from '@modern-js/runtime/head';
import { useEffect } from 'react';
import { GlobalProvider } from './globalProvider';
import { UserAuthProvider } from './auth';
import { getSystem } from '@/utils';
import { getMeetingEnvByHostname } from '@/utils/meetingEnv';

const getMobileRootUrl = () => {
  const env = getMeetingEnvByHostname(window.location.hostname);
  return {
    development: 'https://meeting-mobile.hkgai.net',
    test: 'https://meeting-mobile-test.hkgai.org',
    production: 'https://meeting-mobile.hkgai.org',
  }[env];
};

export default function Layout() {
  const systemInfo = getSystem();
  const isPc = systemInfo === 'pc';
  const location = useLocation();

  const redirectURL = getMobileRootUrl();

  useEffect(() => {
    const currentPath = location.pathname;

    // 如果是PC端用户访问/h5/**路径，跳转到/notebook
    if (isPc && currentPath.startsWith('/h5')) {
      const redirectPath = '/notebook';
      window.location.replace(redirectPath);
    }

    // 如果是移动端用户，都跳到redirectPath
    if (!isPc) {
      const redirectPath = `${redirectURL}/h5`;
      if (window.location.href !== redirectPath) {
        window.location.replace(redirectPath);
      }
    }
  }, [isPc, location.pathname, redirectURL]);

  return (
    <>
      <Helmet bodyAttributes={{ class: `${isPc ? 'my-pc' : 'my-h5'}` }}>
        <title>HKMeeting</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <meta httpEquiv="Expires" content="0" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="screen-orientation" content="portrait" />
        <meta name="full-screen" content="true" />
        <meta name="x5-fullscreen" content="true" />
        <meta name="x5-orientation" content="portrait" />
        <meta name="360-fullscreen" content="true" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta httpEquiv="Cache-Control" content="no-siteapp" />
      </Helmet>

      <Provider>
        <GlobalProvider>
          <UserAuthProvider>
            <>
              <Outlet />
            </>
          </UserAuthProvider>
        </GlobalProvider>
      </Provider>
    </>
  );
}
